import React from 'react';
import classnames from 'classnames';
import ReactSelect, { components } from 'react-select';
import { Props as SelectProps } from 'react-select';
import { IconSvg } from '../../common/IconSvg';
import { Box } from '../../common/Box';
import { getCustomStyles, clearButton, Icon } from './styles';
import { Button } from '../../common/Button';

export interface Props extends SelectProps {
  testIdClearIndicator?: string;
}

const renderDropdownIndicator = () => {
  return (
    <Box marginRight={14}>
      <IconSvg src="dropdown" />
    </Box>
  );
};

const renderLoadingIndicator = () => {
  return (
    <Box marginRight={10}>
      <IconSvg src="preloader" />
    </Box>
  );
};

const renderOption = (props: any) => {
  const { label, data } = props;

  return (
    <div data-option-value={props.data.value}>
      <components.Option {...props}>
        {data.iconUrl && <Icon src={data.iconUrl} alt="" />}
        <span>{label}</span>
      </components.Option>
    </div>
  );
};

export function Select(props: Props) {
  const { testIdClearIndicator } = props;

  const renderClearIndicator = (props: any) => {
    const {
      innerProps: { ref, ...restInnerProps }
    } = props;

    return (
      <Box marginRight={12} css={clearButton}>
        <Button
          data-testid={testIdClearIndicator}
          view="transparent"
          shape="circle"
          size="small"
          className="select-button-remove"
          {...restInnerProps}
          ref={ref}
        >
          <IconSvg src="close" />
        </Button>
      </Box>
    );
  };

  return (
    <ReactSelect
      styles={getCustomStyles()}
      isSearchable={false}
      classNamePrefix="react-select"
      {...props}
      components={{
        IndicatorSeparator: null,
        DropdownIndicator: renderDropdownIndicator,
        LoadingIndicator: renderLoadingIndicator,
        ClearIndicator: renderClearIndicator,
        Option: renderOption,
        ...props.components
      }}
      className={classnames('react-select__container', props.className)}
    />
  );
}
